import { render, staticRenderFns } from "./TributeSettings.vue?vue&type=template&id=27e78d26&scoped=true"
import script from "./TributeSettings.vue?vue&type=script&lang=js"
export * from "./TributeSettings.vue?vue&type=script&lang=js"
import style0 from "./TributeSettings.vue?vue&type=style&index=0&id=27e78d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e78d26",
  null
  
)

export default component.exports